import { FormGroup } from '@angular/forms';

import {
  DocumentModel,
  DocumentModelNoFolderId,
} from '@lockton-apps/client-gateway/interfaces';
import { DocumentTag } from '@lockton-apps/shared/interfaces';

export type DocumentUploadRow = {
  document: File;
  formGroup: FormGroup;
};

export interface DocumentDialogData {
  files?: File[];
  path?: string[];
  pathPrefix?: string;
  clientId: number;
  policyId?: number | null;
  documentFolderId: number;
  acceptedFileTypes?: string[];
  acceptedFileTypesDescription?: string;
  defaultValues?: DocumentUploadModel;
}

export interface DocumentUploadModel {
  category?: string;
  tags?: string[];
  visibility?: boolean;
  deletionDays?: number;
}

export interface AdminDocumentDialogData extends DocumentDialogData {
  categoryOptions?: string[];
  tags: DocumentTag[];
  portalId?: number;
}

export interface DocumentDialogResult {
  documents: DocumentModel[];
}

export interface DocumentDialogResultWithFolder {
  documents: DocumentModelNoFolderId[];
  folderName: string;
}

export function isDocumentsWithFolderResult(
  documentResult: any
): documentResult is DocumentDialogResultWithFolder {
  return (
    (documentResult as DocumentDialogResultWithFolder)?.folderName !== undefined
  );
}

export function isDocumentsOnlyResult(
  documentResult: any
): documentResult is DocumentDialogResult {
  return (documentResult as DocumentDialogResult)?.documents !== undefined;
}
